import { actividadApi } from '../../utils/api';
import {
  getObjectDataAction,
  createObjectDataPending,
  getListDataAction,
  saveObjectDataAction,
  deleteObjectDataAction,
  getListDeletedDataAction,
  createListDataDeletedPending,
  restoreObjectDataAction,
  getListByParentDataAction,
} from '../../utils/DataAction';

export const get = (id) =>
  getObjectDataAction({
    dataName: 'ACTIVIDAD',
    api: actividadApi,
    relUrl: id,
  });

export const getAllByParent = (id) =>
  getListByParentDataAction({
    dataName: 'ACTIVIDAD',
    api: actividadApi,
    relUrl: `indexByParent/${id}`,
  });

export const getAll = getListDataAction({
  dataName: 'ACTIVIDAD',
  api: actividadApi,
  relUrl: '',
});

export const save = (data) =>
  saveObjectDataAction({
    dataName: 'ACTIVIDAD',
    api: actividadApi,
    relUrl: '',
    data: data,
  });

export const deleted = (id) =>
  deleteObjectDataAction({
    dataName: 'ACTIVIDAD',
    api: actividadApi,
    relUrl: id,
  });

export const getAllDeleted = getListDeletedDataAction({
  dataName: 'ACTIVIDAD',
  api: actividadApi,
  relUrl: 'restore',
});

export const restore = (data) =>
  restoreObjectDataAction({
    dataName: 'ACTIVIDAD',
    api: actividadApi,
    relUrl: 'restore',
    data: data,
  });

export const setPending = createObjectDataPending('ACTIVIDAD');
export const setDeletedPending = createListDataDeletedPending('ACTIVIDAD');
